import { flashNews } from "@/mocks/home";
import Reveal from "@/components/base/Reveal";

export default function FlashNews() {
  return (
    <section id="flash" className="scroll-mt-24 border-y border-background-200/80 bg-background-100/60">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[300px_1fr] lg:gap-14">
          <Reveal>
            <div className="lg:sticky lg:top-28">
              <p className="text-xs tracking-widest text-primary-600">FAST FEED</p>
              <h2 className="font-heading mt-2 text-2xl font-bold text-foreground-950 md:text-3xl">
                快讯速览
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                把最近 24 小时里值得留意的内部动静并排放在一起，短句呈现，一眼扫完。想看更深的，再点进对应条目。
              </p>
              <div className="mt-5 flex items-center gap-3 border-t border-background-300/70 pt-4">
                <span className="font-heading text-3xl font-bold text-foreground-950">
                  {flashNews.length}
                </span>
                <span className="text-xs text-foreground-500">
                  条更新
                  <br />
                  滚动查看全部
                </span>
              </div>
            </div>
          </Reveal>

          <div>
            <ul>
              {flashNews.map((item, index) => (
                <Reveal as="li" key={`${item.time}-${item.title}`} delay={index * 50}>
                  <a
                    href="#exclusive"
                    className="group flex items-center gap-3 border-b border-background-300/60 py-3.5 md:gap-5"
                  >
                    <span className="w-12 shrink-0 text-xs tabular-nums text-foreground-400 md:w-14">
                      {item.time}
                    </span>
                    <span className="shrink-0 rounded-md border border-secondary-200 bg-secondary-50 px-2 py-0.5 text-xs text-secondary-900">
                      {item.tag}
                    </span>
                    <span className="flex-1 text-sm leading-snug text-foreground-800 transition-colors group-hover:text-primary-700">
                      {item.title}
                    </span>
                    <span className="flex h-4 w-4 shrink-0 items-center justify-center text-foreground-300 transition-colors group-hover:text-primary-500">
                      <i className="ri-arrow-right-up-line" aria-hidden="true" />
                    </span>
                  </a>
                </Reveal>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}